// Product IDs for the Book Configurator
// Update these if products are recreated in Django admin
export const BOOK_PRODUCT_ID = 9;           // "Personalized AI Book"
export const LANGUAGE_ADDON_PRODUCT_ID = 7; // "Non-English Language Add-on" (free)
export const PRINT_PRODUCT_ID = 8;          // "Printed Copy" — price varies by qty

// PRICING: These are now fetched from backend API and stored in Redux
// See usePricing hook to access pricing in React components
// Screens should use the custom hook: const { additionalCopyPrice, bookCreationWithCopyPrice, ... } = usePricing();

